(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/authorization/assets/javascript/utils.js') >= 0) return;  svs.modules.push('/modules/authorization/assets/javascript/utils.js');

'use strict';

const {
  dialog: dialogComp
} = svs.ui;
const {
  POST_MESSAGE_SOURCE,
  TARGET_ORIGIN,
  TRUSTED_ORIGIN,
  POST_MESSAGE_TYPES,
  isInIamIframe
} = svs.authorization.constants;

const postMessageToParent = message => {
  if (isInIamIframe) {
    if (Object.values(POST_MESSAGE_TYPES).includes(message.type)) {
      window.parent.postMessage({
        value: message.value,
        source: POST_MESSAGE_SOURCE,
        messageType: message.type
      }, TARGET_ORIGIN);
    }
  }
};

const showDialog = (title, errorMessage) => new Promise(resolve => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.TUR,
    icon: 'exclamation-sign',
    area: dialogComp.area.POPUP,
    type: dialogComp.type.ERROR,
    title,
    message: [{
      type: dialogComp.message.TEXT,
      text: errorMessage,
      align: dialogComp.message.align.CENTER
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  dialogComp.api.add(dialog);
});
const buildOnboardingUrl = () => {
  let url = '';
  let shouldPost = false;
  let returnUrl = svs.core.urlMapping.get('newCustomer');
  if (svs.authorization.data.isPnP) {
    shouldPost = true;
    const shouldRedirectToMaxLimit = svs.utils.cookie.read('redirect-to-maxlimit');
    const quicklimits = svs.core.urlMapping.get('quickLimits');
    if (shouldRedirectToMaxLimit) {
      url = svs.core.urlMapping.get('maxLimit');
      returnUrl = quicklimits;
    } else {
      url = quicklimits;
      returnUrl = svs.core.urlMapping.get('pnpHome');
    }
  } else {
    url = svs.core.urlMapping.get('myProfileLimits');
  }
  return {
    url,
    returnUrl,
    shouldPost
  };
};
const parentTrackEvent = trackingObject => {
  if (isInIamIframe) {
    return new Promise(resolve => {
      const requestId = "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
      let resolved = false;
      function handler(event) {
        if ((event.origin === TRUSTED_ORIGIN || event.origin === window.location.origin) && event.data && event.data.source === 'svs-iam-parent' && event.data.requestId === requestId && event.data.messageType === POST_MESSAGE_TYPES.PARENT_TRACK_EVENT_RESOLVED) {
          window.removeEventListener('message', handler);
          resolved = true;
          resolve();
        }
      }
      window.addEventListener('message', handler);
      postMessageToParent({
        type: POST_MESSAGE_TYPES.PARENT_TRACK_EVENT,
        value: trackingObject,
        requestId
      });
      setTimeout(() => {
        if (!resolved) {
          window.removeEventListener('message', handler);
          resolve();
        }
      }, 2000);
    });
  }
  return new Promise(resolve => {
    svs.components.analytics.trackEvent(trackingObject, () => {
      resolve();
    });
  });
};
const saveUserId = async () => {
  const res = await svs.core.jupiter.callAsync({
    path: '/player/2/customizedsettings',
    method: 'Get'
  });
  const response = res.response;
  let userId = null;
  try {
    if (response.customizedSettings && response.customizedSettings.properties) {
      svs.accountservices.utils.user.saveToSessionStorage(response.customizedSettings.properties);
      userId = response.customizedSettings.properties.accountName || null;
      const relevant = response.customizedSettings.properties.relevantContent || false;
      const personalizedConsent = new svs.components.analytics.customEvents.WebConsentChanged(relevant);
      personalizedConsent.track();
    }
  } catch (error) {
    svs.authorization.logger.warn("Error on tracking in saveUserId: ".concat(error));
  }
  const setUserSessionId = () => new Promise(resolve => {
    svs.core.userSession.set('userId', userId, error => {
      if (error) {
        svs.authorization.logger.warn("failed to set userId to userSession, data was: ".concat(userId, ", error was: ").concat(error));
      } else {
        svs.authorization.logger.info("set userId in userSession to: ".concat(userId));
      }
      resolve();
    });
  });
  return setUserSessionId();
};
const checkPeP = () => new Promise(resolve => {
  let kycStatus = null;
  svs.ui.loader.hide();
  svs.core.jupiter.call({
    method: 'GET',
    path: '/player/2/customizedsettings'
  }, response => {
    var _response$customizedS;
    let userId = null;
    if (svs.authorization.data.isPnP && !((_response$customizedS = response.customizedSettings) !== null && _response$customizedS !== void 0 && (_response$customizedS = _response$customizedS.properties) !== null && _response$customizedS !== void 0 && (_response$customizedS = _response$customizedS.onlineFlags) !== null && _response$customizedS !== void 0 && _response$customizedS.hasLoggedInPnP)) {
      svs.core.jupiter.call({
        method: 'PUT',
        path: '/player/1/onlineflag/hasLoggedInPnP'
      }, () => {}, err => {
        svs.authorization.error('Unable to PUT to set flag hasLoggedInPnP at /player/1/onlineflag/hasLoggedInPnP', err);
      });
    }
    if (response.customizedSettings && response.customizedSettings.properties && response.customizedSettings.properties.accountName) {
      userId = response.customizedSettings.properties.accountName;
      kycStatus = response.customizedSettings.properties.kycStatus;
    }
    const kycResolveFn = resolveCallback => {
      var _svs$authorization$da;
      svs.core.userSession.set('customerFirstSession', Boolean(((_svs$authorization$da = svs.authorization.data.sessionData) === null || _svs$authorization$da === void 0 ? void 0 : _svs$authorization$da.progressStatus) === 20), error => {
        if (error) {
          svs.authorization.logger.warn('Error setting customerFirstSession to true', error);
        } else {
          svs.authorization.logger.info('Set customerFirstSession to true');
        }
        if (userId && userId.toString().length) {
          svs.authorization.logger.info('Setting userId to userSession');
          svs.core.userSession.set('userId', userId, () => {
            svs.core.userSession.set('needsNewCustomerLog', true, () => {
              resolveCallback(kycStatus);
            });
          });
        } else {
          svs.authorization.logger.info('Did not find any userId in customizedSettings after registering customer');
          svs.core.userSession.set('needsNewCustomerLog', true, () => {
            resolveCallback(kycStatus);
          });
        }
      });
    };
    async function trackAdobeUser(resolveCallback, _ref) {
      let {
        customizedSettings
      } = _ref;
      try {
        customizedSettings && (await svs.core.analytics.trackAdobeUser(customizedSettings.properties.accountName));
      } catch (error) {
        svs.authorization.logger.info('Error trying to call svs.core.analytics.trackAdobeUser', error);
      }
      kycResolveFn(resolveCallback);
    }
    if (typeof Promise === 'function') {
      trackAdobeUser(resolve, response);
    } else {
      kycResolveFn(resolve);
    }
  }, error => {
    svs.authorization.logger.info('Error trying to get userId from customized settings', error);
    svs.core.userSession.set('needsNewCustomerLog', true, () => {
      resolve(kycStatus);
    });
  });
});
svs.authorization.utils = {
  POST_MESSAGE_TYPES,
  isInIamIframe,
  saveUserId,
  checkPeP,
  postMessageToParent,
  buildOnboardingUrl,
  showDialog,
  parentTrackEvent
};

 })(window);